import { Component, inject, OnInit } from '@angular/core';

import { FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import appPackage from 'package.json';
import { SharedModule } from '@shared/shared.module';
import { hasErrorAndTouched } from '@shared/utils';
import { LocalizationService } from 'src/app/internationalization/localization.service';
import { pageUrls } from 'src/app/configuration/pages';
import { PasswordForgetService } from './service/password-forget.service';
import { ValidationMessageService } from '@shared/validators';

@UntilDestroy()
@Component({
  selector: 'app-password-forget',
  templateUrl: './password-forget.component.html',
  styleUrls: ['./password-forget.component.scss'],
  imports: [SharedModule],
})
export class PasswordForgetComponent implements OnInit {
  readonly hasErrorAndTouched = hasErrorAndTouched;
  protected readonly validationMessageService = inject(ValidationMessageService);
  private translateService = inject(LocalizationService);
  readonly title;
  appName = appPackage.title;
  appVersion = `v${appPackage.version}`;
  isSubmitting = false;
  passwordForgetForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  constructor(
    private fb: FormBuilder,
    private titleService: Title,
    private router: Router,
    private passwordForgetService: PasswordForgetService,
  ) {
    this.title = this.translateService.translate('passwordForget.passwordForgot');
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
  }

  get disableSubmitForm(): boolean {
    return this.passwordForgetForm.invalid || this.isSubmitting;
  }

  onSubmit() {
    this.isSubmitting = true;
    const { email } = this.passwordForgetForm.value;

    if (!email) return;

    this.passwordForgetService
      .forgetPassword(email, `${document.location.origin}/${pageUrls.passwordReset}`)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.passwordForgetForm.reset();
        },
        complete: () => {
          this.isSubmitting = false;
        },
      });
  }

  redirectLogin() {
    return this.router.navigateByUrl(`/${pageUrls.login}`, { replaceUrl: true });
  }
}
